import { Injectable, TemplateRef } from '@angular/core';
import {
  ADMIN_TOAST_DEFAULTS,
  ADMIN_TOAST_TITLE,
  AdminToastKind,
} from '../constants/admin-toast';

export type AdminToastOverrides = Partial<{ classname: string; delay: number }>;
export type ToastText = string | TemplateRef<unknown>;

export interface ToastItem {
  textOrTpl: ToastText;
  caption: ToastText;
  classname?: string;
  delay?: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: ToastItem[] = [];

  show(textOrTpl: ToastText, caption: ToastText, options: Partial<ToastItem> = {}): void {
    this.toasts.push({ textOrTpl, caption, ...options });
  }

  remove(toast: ToastItem): void {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  /** Toast admin: título Éxito + estilo verde estándar. */
  showAdminSuccess(message: string, overrides: AdminToastOverrides = {}): void {
    this.showAdminToast('success', message, overrides);
  }

  /** Toast admin: título Error + estilo peligro estándar. */
  showAdminError(message: string, overrides: AdminToastOverrides = {}): void {
    this.showAdminToast('error', message, overrides);
  }

  /** Toast admin: título Atención + estilo advertencia (texto oscuro sobre fondo warning). */
  showAdminAttention(message: string, overrides: AdminToastOverrides = {}): void {
    this.showAdminToast('attention', message, overrides);
  }

  private showAdminToast(kind: AdminToastKind, message: string, overrides: AdminToastOverrides): void {
    const defaults = ADMIN_TOAST_DEFAULTS[kind];
    this.show(ADMIN_TOAST_TITLE[kind], message, {
      classname: overrides.classname ?? defaults.classname,
      delay: overrides.delay ?? defaults.delay,
    });
  }
}
